













import Vue from 'vue'
import { Injector } from '@/config/dependency-injection'
import { VueRouter } from 'vue-router/types/router'
import { RouterToken } from '@/config/injection-tokens'
import Component from 'vue-class-component'
import UnifyHero from '@/shared/components/unify/unify-hero.vue'

@Component({
  components: { UnifyHero },
})
export default class LandingPage extends Vue {
  public type = ''

  private router = Injector.get<VueRouter>(RouterToken)

  public mounted() {
    this.type = (this.router.currentRoute.query.type as string) || ''

    setTimeout(() => {
      this.router.push({
        name: 'home',
      })
    }, 5000)
  }
}
